export default __webpack_public_path__ + "static/media/clear.a774a7e0.svg";